import React, { useCallback, useEffect, useMemo, useState } from 'react';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import TextField from '@mui/material/TextField';
import store from './../../../../../store';
import { useTranslation } from 'react-i18next';
import { Field } from 'redux-form';
import { getTeachersForSupport } from '../../../../../actions/groups';
import { Autocomplete } from '@mui/material';
import { useSelector } from 'react-redux';

const renderAutocomplete = ({ input, meta, options, label }) => {
    const [inputValue, setInputValue] = useState('');

    return (
        <Autocomplete
            id="teacher-filter-select"
            value={options.find(option => option.id === input.value) || null}
            inputValue={inputValue}
            onChange={(event, newValue) => {
                input.onChange(newValue ? newValue.id : null);
            }}
            onInputChange={(event, newInputValue) => {
                setInputValue(newInputValue);
            }}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            getOptionLabel={option => option?.label || ''}
            options={options}
            renderInput={params => (
                <TextField
                    {...params}
                    error={meta.touched && !!meta.error}
                    label={label}
                    helperText={meta.touched && meta.error ? meta.error : ''}
                />
            )}
        />
    );
};

const fetchData = () => {
    getTeachersForSupport()(store.dispatch, store.getState);
};

const TeacherSelectField = ({ label, code }) => {
    const { t } = useTranslation();
    const selectedTeacher = useSelector(state => state.groups.teacher_select.teacher);

    useEffect(() => {
        fetchData();
    }, []);

    const formattedSelctedTeacher = useMemo(() => {
        if (!selectedTeacher) return [];
        return selectedTeacher.map(item => ({
            id: item.id,
            label: `${item.last_name} ${item.first_name}`,
        }));
    }, [selectedTeacher]);

    return (
        <Card>
            <CardContent>
                <Typography gutterBottom variant="h6" component="h2">
                    {t(label)}
                </Typography>
                <Field
                    name={code}
                    component={renderAutocomplete}
                    options={formattedSelctedTeacher}
                    label={t('filter.choose_teacher')}
                />
            </CardContent>
        </Card>
    );
};

export default TeacherSelectField;
